import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { LanguageService } from '@core/services/language.service';

@Pipe({
    name: 'localCurrency',
    pure: false
})
export class LocalCurrencyPipe implements PipeTransform {
    private languageService = inject(LanguageService);

    transform(value: number, currencyCode = 'EUR', display = 'symbol', digitsInfo?: string): string | null {
        const pipe = new CurrencyPipe(this.languageService.currentLang.code || 'fr');
        return pipe.transform(value, currencyCode, display, digitsInfo);
    }
}
